import request from '@/utils/request'
import qs from 'qs'

const api = {
  getOne: '/open/getOne', //医院介绍
  getkslist:'/hospital/getkslist',//科室信息
  getyslist:'/hospital/getyslist',//医生信息
  getDoctorDetail:'/hospital/getDoctorDetail'//医生详情
}
export function getHispitalInfo() {
  return request({
    url: api.getOne,
    method: 'post'
  })
}
export function getkslist() {
  return request({
    url: api.getkslist,
    method: 'post'
  })
}
export function getyslist(parameter) {
  return request({
    url: api.getyslist,
    method: 'post',
	params: parameter
  })
}
export function getDoctorDetail(parameter) {
  return request({
    url: api.getDoctorDetail,
    method: 'post',
	params: parameter
  })
}


